/**
 * Som neste aparelho — parte D1 (01/10/2026).
 *
 * Por APARELHO, de propósito: a mesma pessoa quer som no computador e silêncio no
 * celular do trabalho. `localStorage["seweb:som-aparelho"]` = "1"/"0"; ausente = ligado.
 * Sem localStorage (janela privada, bloqueio): vale ligado, e a escolha da sessão fica
 * na memória da aba (spec §9).
 *
 * O armazém é parâmetro (padrão: `window.localStorage`): no happy-dom o Storage é um
 * Proxy que liga os métodos na instância, e espionar o protótipo não é confiável.
 */

export const CHAVE_DO_SOM_DO_APARELHO = "seweb:som-aparelho";
const EVENTO_NA_ABA = "seweb:som-aparelho";

export type Armazem = Pick<Storage, "getItem" | "setItem">;

let naMemoria: boolean | null = null;

/** O `localStorage` da aba, ou `null` se o acesso lançar (janela privada, bloqueio).
 *  Exportado para a janela do som (Task 14) usar o mesmo critério, sem copiar. */
export function armazemPadrao(): Armazem | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function somDoAparelhoLigado(armazem: Armazem | null = armazemPadrao()): boolean {
  if (armazem) {
    try {
      const bruto = armazem.getItem(CHAVE_DO_SOM_DO_APARELHO);
      if (bruto === "0") return false;
      if (bruto === "1") return true;
    } catch {
      // indisponível: vale a memória da aba
    }
  }
  return naMemoria ?? true;
}

export function definirSomDoAparelho(
  ligado: boolean,
  armazem: Armazem | null = armazemPadrao()
): void {
  naMemoria = ligado;
  if (armazem) {
    try {
      armazem.setItem(CHAVE_DO_SOM_DO_APARELHO, ligado ? "1" : "0");
    } catch {
      // vale a memória da aba
    }
  }
  // O evento `storage` só chega às OUTRAS abas; o sino e a tela de preferências
  // da mesma aba ouvem este.
  window.dispatchEvent(new Event(EVENTO_NA_ABA));
}

export function ouvirSomDoAparelho(aoMudar: () => void): () => void {
  const aoStorage = (e: StorageEvent) => {
    if (e.key === null || e.key === CHAVE_DO_SOM_DO_APARELHO) aoMudar();
  };
  window.addEventListener(EVENTO_NA_ABA, aoMudar);
  window.addEventListener("storage", aoStorage);
  return () => {
    window.removeEventListener(EVENTO_NA_ABA, aoMudar);
    window.removeEventListener("storage", aoStorage);
  };
}

/** Só para os testes. */
export function _reiniciarSomDoAparelhoParaTeste(): void {
  naMemoria = null;
}
